// components/Footer.js
import React from 'react';
import '../styles/HeaderFooter.css';

const Footer = () => {
  return (
    <footer className="footer shell">
      <div className="footer__brand">
        <div className="footer__logo">ID</div>
        <div>
          <p className="footer__title">IDECACE • Pesquisa de Satisfação</p>
          <p className="footer__subtitle">Operado por DataSavvy • Dados com propósito</p>
        </div>
      </div>

      <div className="footer__links">
        <div>
          <p className="footer__section">Atalhos</p>
          <ul className="nav-list column">
            <li><a href="/admin">Painel</a></li>
            <li><a href="/auditoria">Auditoria</a></li>
            <li><a href="/">Dashboard Público</a></li>
          </ul>
        </div>
        <div>
          <p className="footer__section">Legal</p>
          <ul className="nav-list column">
            <li><a href="https://datasavvy.com.br/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacidade</a></li>
            <li><a href="https://datasavvy.com.br/privacy-policy/" target="_blank" rel="noopener noreferrer">Termos de Uso</a></li>
          </ul>
        </div>
      </div>

      <div className="footer__copy">© {new Date().getFullYear()} IDECACE & DataSavvy. Todos os direitos reservados.</div>
    </footer>
  );
};

export default Footer;